export interface PartnerOpportunityManufacturerMember {
  id: number;
  name: string | null;
}

export interface PartnerOpportunity {
  id: number;
  memberId: number;
  /** Stored for search/API; use opportunityDisplayHeading() for UI. */
  title: string;
  description?: string | null;
  companyName?: string | null;
  seekingType?: string | null;
  status?: string | null;
  dateCreated?: string | null;
  dateUpdated?: string | null;
  dateSubmitted?: string | null;
  dateApproved?: string | null;
  expiresOn?: string | null;
  createdByUserId?: number | null;
  approvedByUserId?: number | null;
  memberName?: string | null;
  /** Region or State — exclusive location mode */
  locationMode?: "Region" | "State" | string;
  regions: string[];
  /** State codes when locationMode is State */
  states: string[];
  categories: string[];
  isFavorite: boolean;
}

export interface PartnerOpportunitySearchRequest {
  keyword?: string;
  seekingType?: string;
  status?: string;
  memberId?: number;
  favoritesOnly?: boolean;
  regions: string[];
  states: string[];
  categories: string[];
  page?: number;
  pageSize?: number;
}

export interface PartnerOpportunitySavedFilter {
  id: number;
  name: string;
  keyword?: string | null;
  regions: string[];
  states: string[];
  categories: string[];
  seekingType?: string | null;
  isEnabled: boolean;
}

export interface PartnerOpportunityMetadata {
  regions: string[];
  categories: string[];
  seekingTypes: string[];
  statuses: string[];
}

export interface PartnerOpportunityRegionOption {
  id: number;
  name: string;
  description?: string | null;
  imageUrl?: string | null;
}

export interface PartnerOpportunityMemberRegionPreferences {
  memberId: number;
  regionOptionIds: number[];
}

export interface PartnerOpportunityMemberStatePreferences {
  memberId: number;
  stateCodes: string[];
}

export interface PartnerOpportunityModerateRequest {
  status: string;
  notes?: string;
}

export interface PartnerOpportunityResponderDto {
  userId: number;
  firstName?: string | null;
  lastName?: string | null;
  emailAddress?: string | null;
  phoneNumber?: string | null;
  memberId?: number | null;
  memberName?: string | null;
  memberCity?: string | null;
  memberState?: string | null;
  memberPhone?: string | null;
  memberWebsite?: string | null;
}

export interface PartnerOpportunityResponseDto {
  id: number;
  partnerOpportunityId: number;
  dateCreated: string;
  message: string;
  responder: PartnerOpportunityResponderDto;
}

export interface PartnerOpportunityMyResponseDto {
  responseId: number;
  partnerOpportunityId: number;
  opportunityTitle: string;
  opportunityCompanyName?: string | null;
  opportunityMemberId: number;
  opportunityMemberName?: string | null;
  opportunitySeekingType?: string | null;
  dateCreated: string;
  message: string;
}

/** UI label; API and stored value remain `Both`. */
export function seekingTypeDisplayLabel(value: string | null | undefined): string {
  const v = (value ?? "").trim();
  if (v === "Both") return "Distributors and Reps";
  return v;
}

/** Primary listing line: "{MemberName} is looking for {seeking type}". */
export function opportunityDisplayHeading(item: {
  memberName?: string | null;
  companyName?: string | null;
  seekingType?: string | null;
}): string {
  const name = (item.memberName ?? item.companyName ?? "").trim() || "Member";
  const seeking = seekingTypeDisplayLabel(item.seekingType);
  return `${name} is looking for ${seeking}`;
}
